import type { LocationStatus, LocationSyncStatus } from '@goelectric/shared-types';
import { LOCATION_STATUS_META, LOCATION_SYNC_META } from '@goelectric/ui-components';
import { StatusBadgeShell, StatusIcon, useStatusColor } from '@/components/StatusBadgeShell';

/** Estado de gestión de la locación: color + icono + texto (WCAG, nunca solo color). */
export function LocationStatusBadge({
  status,
  forceDark = false,
}: {
  status: LocationStatus;
  forceDark?: boolean;
}) {
  const meta = LOCATION_STATUS_META[status];
  const color = useStatusColor(meta.color, meta.colorDark, forceDark);
  return (
    <StatusBadgeShell
      color={color}
      icon={<StatusIcon iconKey={meta.iconKey} />}
      label={meta.label}
      title={`${meta.label}: ${meta.description}`}
    />
  );
}

/** Estado de sincronización de la Location con CitrineOS (ADR 0024). */
export function LocationSyncBadge({
  status,
  forceDark = false,
}: {
  status: LocationSyncStatus;
  forceDark?: boolean;
}) {
  const meta = LOCATION_SYNC_META[status];
  const color = useStatusColor(meta.color, meta.colorDark, forceDark);
  return (
    <StatusBadgeShell
      color={color}
      icon={<StatusIcon iconKey={meta.iconKey} />}
      label={meta.label}
      title={`${meta.label}: ${meta.description}`}
    />
  );
}
